import requestAnalytics from '@/utils/requestAnalytics'

const END_POINT = '/streamdata'
const api = {}

api.sendForm = (payload) => requestAnalytics.post(END_POINT, payload)

export default api
